import React from 'react'
import { useTranslation } from 'react-i18next'

export const CTASection: React.FC = () => {
  const { t } = useTranslation()
  const cta = t('cta', { returnObjects: true }) as any

  const redirectToApp = () => {
    const mainAppUrl = import.meta.env.VITE_MAIN_APP_URL || 'https://app.nazwolab.pl'
    window.location.href = mainAppUrl
  }

  return (
    <section className="py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-gradient-to-br from-blue-600 to-purple-700 rounded-2xl p-12 shadow-2xl">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {cta.title}
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            {cta.description}
          </p>
          <button
            onClick={redirectToApp}
            className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-50 transition-all duration-200 text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            {cta.button}
            <span className="ml-2">→</span>
          </button>
          <p className="text-blue-200 text-sm mt-4">
            {cta.noCard}
          </p>
        </div>
      </div>
    </section>
  )
}